import script from "./software-disabled-edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./software-disabled-edit.vue?vue&type=script&setup=true&lang=ts"

import "./software-disabled-edit.vue?vue&type=style&index=0&id=2214f894&lang=scss&scoped=true"
import "./software-disabled-edit.vue?vue&type=style&index=1&id=2214f894&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2214f894"]])

export default __exports__